import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=00efc6d4&scoped=true"
import script from "./SkeletonLoading.vue?vue&type=script&lang=ts"
export * from "./SkeletonLoading.vue?vue&type=script&lang=ts"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=00efc6d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00efc6d4",
  null
  
)

export default component.exports